/**
 * Created by nijin on 28/12/16.
 */
import {Component, ContentChildren, QueryList, AfterContentInit, Output, EventEmitter} from '@angular/core';
import {SchemaTab} from "./schema-tab";

@Component({
  selector: 'schema-edit-tabs',
  template:`
    <ul class="nav nav-tabs attLocTabs">
      <li *ngFor="let tab of tabs" (click)="selectTab(tab)" 
        [id]="tab.id" [class.active]="tab.active" class="tab">
        <a> <span class="icon" [ngClass]="tab.icon"></span> <span>{{tab.title}}</span></a>
      </li>
    </ul>
    <div class="col-md-12 seperator"><hr></div>
    <ng-content></ng-content>
  `,
    styleUrls:['./schema-tabs.component.scss']
})
export class SchemaEditTabs implements AfterContentInit {

  @ContentChildren(SchemaTab) tabs: QueryList<SchemaTab>;
  @Output() changeTab: EventEmitter<any> = new EventEmitter<any>();

  // contentChildren are set
  ngAfterContentInit() {

  }

  selectTab(tab: SchemaTab){
    // deactivate all tabs
    this.tabs.toArray().forEach(tab => tab.active = false);

    // activate the tab the user has clicked on.
    tab.active = true;
    this.changeTab.emit(tab.title);
  }


}






// WEBPACK FOOTER //
// ./src/app/schema/edit-schema/location/schema-tabs.component.ts